import { render, staticRenderFns } from "./UjianMapelList.vue?vue&type=template&id=4056070c&scoped=true"
import script from "./UjianMapelList.vue?vue&type=script&lang=js"
export * from "./UjianMapelList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4056070c",
  null
  
)

export default component.exports